import type { Locale } from "./i18n";

const EN_LABELS: Record<string, string> = {
  ASANA: "Asana",
  CLICKUP: "ClickUp",
  GOOGLE_CALENDAR: "Google Calendar",
  GMAIL: "Gmail",
  GITHUB: "GitHub",
  GITLAB: "GitLab",
  AIRTABLE: "Airtable",
  HUBSPOT: "HubSpot",
  ZOOM: "Zoom",
  INTERCOM: "Intercom",
  CALENDLY: "Calendly",
  MIRO: "Miro",
  GOOGLE_SHEETS: "Google Sheets",
  PIPEDRIVE: "Pipedrive",
  DISCORD: "Discord",
  PAGERDUTY: "PagerDuty",
  WEBEX: "Webex",
  SENTRY: "Sentry",
  ZOHO_CRM: "Zoho CRM",
  STRIPE: "Stripe",
  TYPEFORM: "Typeform",
  JIRA: "Jira Cloud",
  LINEAR: "Linear",
  MONDAY: "monday.com",
  SMARTSHEET: "Smartsheet",
  TRELLO: "Trello",
  ONEDRIVE: "OneDrive",
  OUTLOOK: "Outlook",
  TEAMS: "Microsoft Teams",
  SHAREPOINT: "SharePoint",
};

const ZH_LABELS: Record<string, string> = {
  ASANA: "Asana",
  CLICKUP: "ClickUp",
  GOOGLE_CALENDAR: "Google 日历",
  GMAIL: "Gmail",
  GITHUB: "GitHub",
  GITLAB: "GitLab",
  AIRTABLE: "Airtable",
  HUBSPOT: "HubSpot",
  ZOOM: "Zoom",
  INTERCOM: "Intercom",
  CALENDLY: "Calendly",
  MIRO: "Miro",
  GOOGLE_SHEETS: "Google 表格",
  PIPEDRIVE: "Pipedrive",
  DISCORD: "Discord",
  PAGERDUTY: "PagerDuty",
  WEBEX: "Webex",
  SENTRY: "Sentry",
  ZOHO_CRM: "Zoho CRM",
  STRIPE: "Stripe",
  TYPEFORM: "Typeform",
  JIRA: "Jira Cloud",
  LINEAR: "Linear",
  MONDAY: "monday.com",
  SMARTSHEET: "Smartsheet",
  TRELLO: "Trello",
  ACCEPTED: "已接受",
  ACCESS: "访问权限",
  ACCOUNT: "账户",
  ACCURACY: "准确性",
  ACTIVE: "已启用",
  ADMIN: "管理员",
  AGENT_RUN: "智能体运行",
  ANALYSIS: "分析",
  ANSWER: "回答",
  ALL: "全部",
  ANY: "全部",
  APPROVE: "批准",
  ARCHIVED: "已归档",
  ASSIGNED: "已分配",
  ATTENTION: "需关注",
  AUDIO: "音频",
  AUTHORITATIVE: "权威",
  AUTO_RESOLVED: "自动解决",
  AVAILABLE: "可用",
  BETA: "Beta 已验证",
  AUTH_REQUIRED: "需要登录",
  BUILDER: "构建者",
  CANDIDATE: "候选",
  CANCELLED: "已取消",
  CITATIONS: "引用",
  CITED_BY: "被引用于",
  CLEARED: "已清除",
  COMPLETED: "已完成",
  CONFIGURATION_REQUIRED: "需要配置",
  CONFIRM: "人工确认",
  CONFLICT: "内容冲突",
  CONNECTED: "已连接",
  CONNECT: "连接",
  CONNECTING: "连接中",
  CONNECTOR: "连接器",
  CONFLUENCE: "Confluence",
  CONNECTOR_SYNC: "连接器同步",
  CONSUME: "消费",
  CREATION: "内容创作",
  CROSS_MODAL: "跨模态重复",
  CURRENT_STATE_WITH_30_DAY_CONSUMPTION: "当前状态（含 30 天消费）",
  CUSTOM: "自定义",
  CRITICAL: "紧急",
  DELETED: "已删除",
  DELETE: "删除",
  DELETE_MY_ACCOUNT: "删除我的账户",
  DELETE_ORGANIZATION: "删除工作区",
  DELETE_USER: "删除用户",
  DISABLED: "已停用",
  DOCUMENT: "文档",
  DROPBOX: "Dropbox",
  DRAFT: "草稿",
  DUPLICATE: "重复内容",
  DUPLICATE_OF: "重复于",
  ENABLED: "已启用",
  ENTERPRISE: "企业版",
  ENTERPRISE_ALLOWED: "企业授权",
  ERROR: "错误",
  EXACT: "完全重复",
  EXCLUDED: "已排除",
  EXPIRED: "已过期",
  EXPORT: "数据导出",
  EXTRACTIVE: "安全提取",
  FAILED: "失败",
  FILE_UPLOAD: "文件上传",
  FORBIDDEN: "无权访问",
  GENERATE: "生成回答",
  GENERATED: "模型生成",
  GOOGLE_DRIVE: "Google Drive",
  GOVERN: "治理",
  HELPFUL: "有帮助",
  HIGH: "高",
  HUMAN_RESOLVED: "人工解决",
  IMAGE: "图片",
  INBOUND: "上游",
  INGEST_UPLOAD: "摄取上传文件",
  INGEST_URL: "摄取网址",
  INGESTION_JOB: "摄取任务",
  INTERNAL: "内部使用",
  INVALID_RESPONSE: "响应无效",
  KNOWLEDGE_OBJECT: "知识对象",
  KNOWLEDGE: "知识",
  LOW: "低",
  LOW_TRUST: "低可信",
  MEDIUM: "中",
  MICROSOFT_365: "Microsoft 365",
  MEMBER: "成员",
  MINE: "分配给我",
  MODEL: "模型",
  NEAR: "近似重复",
  NOT_HELPFUL: "需改进",
  NONE: "无",
  NORMALIZE: "规范化",
  NOTION: "Notion",
  ONEDRIVE: "OneDrive",
  OUTLOOK: "Outlook",
  TEAMS: "Microsoft Teams",
  OK: "正常",
  OPENAI_COMPATIBLE: "OpenAI 兼容接口",
  OAUTH: "OAuth 授权",
  OTHER: "其他",
  OWNER: "所有者",
  OUTBOUND: "下游",
  PASSED: "已通过",
  PAUSED: "已暂停",
  PENDING: "待处理",
  PERMISSION: "权限问题",
  PLATFORM: "平台",
  PROCESS_PRIVACY_JOB: "处理隐私任务",
  PUBLIC_URL: "公开网址",
  QUEUED: "排队中",
  READY: "就绪",
  READ_ONLY: "只读",
  RECALCULATE: "重新计算",
  RECALCULATE_TRUST: "重新计算可信度",
  REJECT: "拒绝",
  REJECTED: "已拒绝",
  REQUEST_INFORMATION: "请求补充信息",
  REQUEST_FAILED: "请求失败",
  RESTORE_SUPPLY: "恢复供应",
  RESTRICTED: "受限",
  RETRIEVE: "检索知识",
  REVIEW: "待复核",
  REVIEWER: "审核员",
  REVOKED: "已撤销",
  RIGHTS: "权利问题",
  ROADMAP: "路线图",
  ROLES: "指定角色",
  RULE: "证据规则",
  RUNNING: "运行中",
  SALESFORCE: "Salesforce",
  SHAREPOINT: "SharePoint",
  SETUP_REQUIRED: "需要配置",
  SET_AUTHORITY: "设为权威",
  SLACK: "Slack",
  SOURCE_OF: "来源于",
  SOURCE_SYSTEM: "来源系统",
  STOPPED: "已停供",
  STOP_SUPPLY: "停止供应",
  SUPERSEDED: "已被取代",
  SURVIVED_AS: "幸存为",
  SUPPLIED_TO: "供应至",
  SUPPLY: "供给",
  SUSPENDED: "已暂停",
  SYNCING: "同步中",
  SYNC_CONNECTOR: "同步连接器",
  TEAM: "团队版",
  TITLE_ASC: "标题升序",
  TRUST_ASC: "可信度升序",
  TRUST_DESC: "可信度降序",
  TRIAL: "试用版",
  UNKNOWN: "未知",
  UNASSIGNED: "未分配",
  UPDATED_ASC: "最早更新",
  UPDATED_DESC: "最近更新",
  UPLOAD: "文件上传",
  URL: "网址",
  USERS: "指定用户",
  VERIFIED_BY: "经验证",
  VERSION_OF: "版本关系",
  VIDEO: "视频",
  WAITING: "等待中",
  WAITING_CONFIRMATION: "等待人工确认",
  WORKSPACE: "整个工作区",
  WRITING: "写作",
  WORKERS_AI: "Cloudflare Workers AI",
  authorityStatus: "权威状态",
  clusterType: "重复类型",
  currentScore: "当前得分",
  duplicateCount: "重复数量",
  database: "数据库",
  objectStorage: "对象存储",
  vectorSearch: "向量检索",
  encryption: "加密服务",
  connectedConnectors: "已连接连接器",
  connectors: "连接器",
  knowledgeObjects: "知识对象",
  authoritativeObjects: "权威知识",
  chunkedObjects: "已索引对象",
  searches30d: "搜索（30 天）",
  answers30d: "回答（30 天）",
  averageTrust: "平均可信度",
  active: "可供给",
  review: "审核中",
  reason: "原因",
  rightsStatus: "权利状态",
  threshold: "阈值",
  connector: "连接器",
  fileUpload: "文件上传",
  publicUrl: "公开网址",
};

export function displayLabel(
  value: string | null | undefined,
  locale: Locale,
): string {
  if (!value) return "—";
  if (locale === "zh" && ZH_LABELS[value]) return ZH_LABELS[value];
  if (locale === "en" && EN_LABELS[value]) return EN_LABELS[value];
  if (/^[A-Z][A-Z0-9_]*$/u.test(value)) {
    const readable = value.replaceAll("_", " ").toLowerCase();
    return `${readable.slice(0, 1).toUpperCase()}${readable.slice(1)}`;
  }
  return value;
}

export function formatDateTime(value: string, locale: Locale): string {
  return new Date(value).toLocaleString(locale === "zh" ? "zh-CN" : "en-US");
}

export function formatDate(value: string, locale: Locale): string {
  return new Date(value).toLocaleDateString(
    locale === "zh" ? "zh-CN" : "en-US",
  );
}
